import React, { useEffect, useState } from "react";
import { Table, Tag, Typography, Button } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import billingService, { Invoice } from "../../services/billing";
import dayjs from "dayjs";

const { Title } = Typography;

export default function BillingHistory() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Invoice[]>([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const history = await billingService.getHistory();
      setData(history || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: "Invoice ID",
      dataIndex: "invoiceId",
      key: "id",
    },
    {
      title: "Date",
      dataIndex: "invoiceDate",
      key: "date",
      render: (date: string) => dayjs(date).format("DD MMM YYYY"),
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (date: string) =>
        date ? dayjs(date).format("DD MMM YYYY") : "-",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (val: number) => `₹${val.toLocaleString()}`,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <Tag color={status === "Paid" ? "green" : "red"}>
          {status || "Unknown"}
        </Tag>
      ),
    },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <Title level={3}>Billing History</Title>
        <Button icon={<SyncOutlined />} onClick={fetchData}>
          Refresh
        </Button>
      </div>
      <div className="bg-white rounded-lg p-4 shadow">
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </div>
    </div>
  );
}
